<template>
    <v-card class="mt-2 ml-2 mr-2">
        <FArticleTable class="pl-2 pr-2" ref="reFArticleTable"/>
    </v-card>
  </template>
  
  <script>
  import FArticleTable from "@/components/admin-e-library/admin-article/FArticleTable.vue";
  
  export default {
    name: "ArticleView",
    components: {
      FArticleTable
    },
    data() {
      return {
      }
    },
    computed: {
    },
    methods: {
    },
  
  
  }
  </script>
  
  <style scoped>
  </style>